var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgZa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-za",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "za-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-71.9 0h682.7v512H-71.9z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#za-a)",
    transform: "translate(67.4)scale(.93748)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M-71.9 407.8V104.4L154 256.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000c8a",
    d: "m82.2 512.1 253.6-170.6H696V512H82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1392d",
    d: "M66 0h630v170.8H335.7S69.3-1.7 66 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb915",
    d: "M-71.9 64v40.4L154 256-72 407.8v40.3l284.5-192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007847",
    d: "M-71.9 64V0h95l301.2 204h371.8v104.2H324.3L23 512h-94.9v-63.9l284.4-192L-71.8 64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 0h59.2l253.6 170.7H696V204H324.3zm0 512.1h59.2l253.6-170.6H696v-33.2H324.3L23 512z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/za.57ed656aa5c93d478f182e2421e3f165.svg";
export { ForwardRef as ReactComponent };